import React from "react";

const RemoveFormatting = ({
	customComponent,
	onClick,
	isActive,
	isDisabled
}) => {
	const removeFormatting = () => {
		if (onClick) onClick();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={removeFormatting}
				title="Remove Formatting"
				type="button"
				disabled={isDisabled}>
				{customComponent ? (
					customComponent
				) : (
					<i className="fas fa-remove-format" />
				)}
			</button>
		</>
	);
};

export default RemoveFormatting;
